var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcellent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7617 33C26.3221 33 33.2617 26.0604 33.2617 17.5C33.2617 8.93959 26.3221 2 17.7617 2C9.2013 2 2.26172 8.93959 2.26172 17.5C2.26172 26.0604 9.2013 33 17.7617 33Z",
    stroke: "#838990",
    strokeWidth: 2.69565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3984 13.625C10.3984 13.1111 10.6026 12.6183 10.9659 12.255C11.3293 11.8916 11.8221 11.6875 12.3359 11.6875C12.8498 11.6875 13.3426 11.8916 13.706 12.255C14.0693 12.6183 14.2734 13.1111 14.2734 13.625",
    stroke: "#838990",
    strokeWidth: 2.69565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0234 13.625C22.0234 13.3706 22.0736 13.1186 22.1709 12.8836C22.2683 12.6485 22.411 12.4349 22.5909 12.255C22.7708 12.0751 22.9844 11.9324 23.2195 11.835C23.4546 11.7376 23.7065 11.6875 23.9609 11.6875C24.2154 11.6875 24.4673 11.7376 24.7024 11.835C24.9375 11.9324 25.151 12.0751 25.331 12.255C25.5109 12.4349 25.6536 12.6485 25.751 12.8836C25.8483 13.1186 25.8984 13.3706 25.8984 13.625",
    stroke: "#838990",
    strokeWidth: 2.69565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9618 21.4658C23.3987 22.5862 22.544 23.5341 21.4876 24.2097C20.4313 24.8853 19.2123 25.2637 17.959 25.3049C16.7057 25.3462 15.4645 25.0488 14.366 24.4441C13.2675 23.8394 12.3523 22.9498 11.7168 21.8688",
    stroke: "#838990",
    strokeWidth: 2.69565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcellent);
export default __webpack_public_path__ + "static/media/excellent.7d8aa19e1b46cfa28a3d2985000cb2f4.svg";
export { ForwardRef as ReactComponent };